(ns ycweb.app.website.cards
  (:require
   #?@(:clj
       [[clj-time.core :as dt]])
   #?@(:cljs
       [[cljs-time.core :as dt]])
   [ajax.core :as ajax]
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.app.website.cart.model :as cart.model]
   [ycweb.app.website.common :as web-common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(defn calculated-saving [price price-was]
  (let [saving (- price-was price)
        save-percent (u/number-format (Math/floor (/ (* saving 100) price-was)))]
    (if (<= price-was 20000)
      (str save-percent "%")
      (str "R" (u/currency-format saving)))))

(rum/defc product-card-default < rum/reactive
  [app-atom
   {:ent/keys [display-name image]
    :product/keys
    [id url brand name-ex-brand special-short-desc sticker-name special-amount time-based-special? favourite-things-sale?
     time-based-special-active? earliest-expected earliest-expected-message product-type num-reviews price max-price price-was
     in-stock avg-rating pack-size all-pack-sizes pack-description new? colours stats made-in ratio-special?
     ratio-special-ratio-qty ratio-special-free-qty special-banner-text time-based-special-soldout?] :as product}
   {:keys [small?] :as options}]
  (let [{:keys [birthday-sale]} (cmn/curact app-atom [:time-based-campaigns])
        num-colours (count colours)
        avg-rating (u/parseInt avg-rating)
        ratio-special-ratio-qty (u/parseInt ratio-special-ratio-qty)
        ratio-special-free-qty (u/parseInt ratio-special-free-qty)
        rating (u/number-format (/ avg-rating 10) 1)
        {:keys [hundred-favourite-things-sale]} (cmn/curact app-atom [:time-based-campaigns])
        process-atom (cmn/process-cursor app-atom)
        done? (:done? (cmn/curact process-atom :countdown-timer))]

    [:article.card.flex-grid-content
     {:class
      (u/bem
        :product-card (if small? [:small] [])
        (when (and time-based-special? (or done? time-based-special-soldout?))
          :special-card--sold-out))}
     [:div.card__hero
      [:a.u-block-link
       (merge
         {:href url}
         (when stats
           {:on-click #(grid/dispatch-action app-atom :search/search-click-stats stats)}))

       (web-common/lazy-image app-atom
         (:doc/public-id image)
         {:class ["card__image"]}
         {:w 233
          :h 233
          :c "lpad"
          :q "auto"
          :f "auto"
          :effect "sharpen:40"
          :border-spec (:doc/padding image)
          :dpr 2
          :alt (str "Image of " display-name)})
       (when new?
         [:div.card__new-sticker-wrapper
          [:div {:class (u/bem :card-sticker [:new])} "New"]])

       (cond
         (and hundred-favourite-things-sale favourite-things-sale?)
         [:span {:class (u/bem :card__graphic-sticker-wrapper [:100-fav-things])}
          [:span.card__graphic-sticker {:class (u/bem :icon [:block :100-favourite-things])}]]

         (and time-based-special? time-based-special-active?)
         [:span.card__graphic-sticker-wrapper
          [:span {:class [(when birthday-sale "u-bg-flamingo") (u/bem :card__graphic-sticker [:time-based])]}]]

         (and ratio-special? (pos? ratio-special-ratio-qty) (pos? ratio-special-free-qty))
         [:div.card__graphic-sticker-wrapper
          [:div.deal-ratio-icon
           [:span.deal-ratio-icon__int ratio-special-ratio-qty]
           [:span.deal-ratio-icon__for "for"]
           [:span.deal-ratio-icon__int (- ratio-special-ratio-qty ratio-special-free-qty)]]]

         (= made-in "South Africa")
         [:div.card__sticker-wrapper-right
          [:div {:class (u/bem :card-sticker [:madeinsa])} "Made in SA"]])

       (when (> (or pack-size 0) 1)
         [:div.card__pack-size-wrapper
          [:span.card__pack-size
           (str pack-description " of " (if all-pack-sizes all-pack-sizes pack-size))]])

       (when (> (or num-colours 0) 1)
         [:div.group {:class (u/bem :card__colour-key [(keyword (str (or num-colours 0)))])}
          [:div.colour-key__description
           [:span.u-hidden-from-view "Available in "]
           num-colours
           [:span.colour-key__qualifier
            {:data-abbr "clr"}
            [:span.colour-key__clip " colours"]]]
          [:div.colour-key__wrapper
           (map
             (fn [colourhex]
               (when (u/presence colourhex)
                 [:div.colour-key__item {:key (str id "-" colourhex) :style {:background-color colourhex}}]))
             (take 5 colours))]])]

      (if (and time-based-special? (or done? time-based-special-soldout?))
        [:div.special-card-feedback
         (cond
           done?
           "Time's up!"

           time-based-special-soldout?
           "Sold out!")]

        (when (= in-stock "No")
          [:a.card-notify-me
           {:href (str url "#notify")}
           [:div.card-notify-me__title "Awaiting stock"]
           [:div.card-notify-me__link "Notify me"]]))]

     [:a.u-block-link
      (merge
        {:href url}
        (when stats
          {:on-click #(grid/dispatch-action app-atom :search/search-click-stats stats)}))
      [:div.card__content-wrapper
       [:div.card__content
        [:header.card__header
         [:div.product-card__meta
          (cond
            (> avg-rating 0)
            [:div
             {:class (u/bem :star-rating [(keyword (str avg-rating)) :small]),
              :title (str rating " out of 5 stars from " num-reviews " reviews")}
             [:span.u-hidden-from-view
              (str rating " out of 5 stars from " num-reviews " reviews")]]

            :else
            [:div
             {:class (u/bem :star-rating [:00 :small]),
              :title "This product has not been reviewed yet."}
             [:span.u-hidden-from-view "This product has not been reviewed yet."]])]

         [:h1.product-card__title
          [:span.product-card__brand brand]
          [:span.product-card__name name-ex-brand]]]
        [:div.card__description

         [:ul.card-price-list.group
          [:li {:class (u/bem :card-price-list__item [(when (> price-was price) :now)])}
           (when (and (> price 0) (> price-was price))
             [:span.u-hidden-from-view "Now "])

           (when (and (> price 0) (not (= price max-price)))
             "From ")

           (cond
             (and
               (= price 0)
               (or (= in-stock "Free") (= product-type "Online Cooking Course")))
             "Free"

             (= price 0)
             "Price TBA"

             (> price 0)
             (str "R" (u/currency-format price)))]

          (when (> price-was price)
            [:li
             {:class (u/bem :card-price-list__item [:was])}
             [:span
              {:class (u/bem :clip-text [:ml :t] :unclip-text [:l :s])}
              "Was "]
             (str "R" (u/currency-format price-was))])]

         (when (and (= in-stock "No") earliest-expected (dt/before? (dt/now) earliest-expected))
           [:p.card__stock-message
            {:class (u/bem :text-status [:important])}
            [:i
             {:class (u/bem :icon [:error-red :small :in-copy-left :inline])}]
            earliest-expected-message])

         (cond
           (u/presence special-short-desc)
           [:div.card__price-sticker-wrapper
            (cond
              (str/includes? (str/lower-case special-short-desc) (str/lower-case "worth"))
              [:div
               {:class (u/bem :card-sticker [:price])}
               (str/subs special-short-desc 0 (str/index-of (str/lower-case special-short-desc) (str/lower-case "worth")))
               [:span.clip-text--t.unclip-text--s
                (str/subs special-short-desc (str/index-of (str/lower-case special-short-desc) (str/lower-case "worth")))
                (when (> (or special-amount 0) 0)
                  (str " R" (u/currency-format special-amount)))]]

              :else
              [:div
               {:class (u/bem :card-sticker [:price])}
               (str special-short-desc (when (> (or special-amount 0) 0) (str " R" (u/currency-format special-amount))))])]

           (and
             (> price-was price)
             (or
               (> (- price-was price) (/ price-was 10))
               (>= (- price-was price) 100)))
           [:div.card__price-sticker-wrapper
            [:div
             {:class (u/bem :card-sticker [:price])}
             "Save " (calculated-saving price price-was)]])

         (when
           (and
             (not special-short-desc)
             (u/presence special-banner-text))
           [:p.card__special-info
            {:dangerouslySetInnerHTML
             {:__html
              (if (u/presence done?)
                [:b.u-text-uppercase.u-text-red "Sorry, time's up!"]
                special-banner-text)}}])]]]]]))

(rum/defc product-card-large < rum/reactive
  [app-atom
   {:ent/keys [display-name image]
    :product/keys
    [id url brand name-ex-brand special-short-desc sticker-name special-amount time-based-special? favourite-things-sale?
     time-based-special-active? earliest-expected earliest-expected-message product-type num-reviews price max-price price-was
     in-stock avg-rating pack-size all-pack-sizes pack-description new? features colours variations stats made-in ratio-special?
     ratio-special-ratio-qty ratio-special-free-qty] :as options}]

  (let [{:keys [birthday-sale]} (cmn/curact app-atom [:time-based-campaigns])
        num-colours (count colours)
        avg-rating (u/parseInt avg-rating)
        ratio-special-ratio-qty (u/parseInt ratio-special-ratio-qty)
        ratio-special-free-qty (u/parseInt ratio-special-free-qty)
        variation-sizes (filter #(u/presence (:variation/size %)) variations)
        variation-colours (filter #(u/presence (:variation/colour %)) variations)
        rating (u/number-format (/ avg-rating 10) 1)
        {:keys [hundred-favourite-things-sale]} (cmn/curact app-atom [:time-based-campaigns])

        new-cart-enabled
        (cmn/curact app-atom [:features :new-cart])]
    [:article.card.product-features-card.flex-grid-content
     [:div.product-features-card__content
      [:div.product-features-card__hero
       [:div.product-features-card__hero-outer
        [:div.product-features-card__hero-inner
         [:a.u-block-link
          (merge
            {:href url}
            (when stats
              {:on-click #(grid/dispatch-action app-atom :search/search-click-stats stats)}))
          (web-common/lazy-image app-atom
            (:doc/public-id image)
            {:class ["card__image"]}
            {:w 233
             :h 233
             :c "lpad"
             :q "auto"
             :f "auto"
             :effect "sharpen:40"
             :border-spec (:doc/padding image)
             :dpr 2
             :alt (str "Image of " display-name)})
          (when new?
            [:div.card__new-sticker-wrapper
             [:div {:class (u/bem :card-sticker [:new])} "New"]])

          (cond
            (and hundred-favourite-things-sale favourite-things-sale?)
            [:span {:class (u/bem :card__graphic-sticker-wrapper [:100-fav-things])}
             [:span.card__graphic-sticker {:class (u/bem :icon [:block :100-favourite-things])}]]

            (and time-based-special? time-based-special-active?)
            [:span.card__graphic-sticker-wrapper
             [:span {:class [(when birthday-sale "u-bg-flamingo") (u/bem :card__graphic-sticker [:time-based])]}]]

            (and ratio-special? (pos? ratio-special-ratio-qty) (pos? ratio-special-free-qty))
            [:div.card__graphic-sticker-wrapper
             [:div.deal-ratio-icon
              [:span.deal-ratio-icon__int ratio-special-ratio-qty]
              [:span.deal-ratio-icon__for "for"]
              [:span.deal-ratio-icon__int (- ratio-special-ratio-qty ratio-special-free-qty)]]]

            (= made-in "South Africa")
            [:div.card__sticker-wrapper-right
             [:div {:class (u/bem :card-sticker [:madeinsa])} "Made in SA"]])

          (when (> (or pack-size 0) 1)
            [:div.card__pack-size-wrapper
             [:span.card__pack-size
              (str pack-description " of " (if all-pack-sizes all-pack-sizes pack-size))]])

          (when (> (or num-colours 0) 1)
            [:div.group {:class (u/bem :card__colour-key [(keyword (str (or num-colours 0)))])}
             [:div.colour-key__description
              [:span.u-hidden-from-view "Available in "]
              num-colours
              [:span.colour-key__qualifier
               {:data-abbr "clr"}
               [:span.colour-key__clip " colours"]]]
             [:div.colour-key__wrapper
              (map
                (fn [colourhex]
                  (when (u/presence colourhex)
                    [:div.colour-key__item {:key (str id "-" colourhex) :style {:background-color colourhex}}]))
                (take 5 colours))]])]

         (when (= in-stock "No")
           [:a.card-notify-me
            {:href (str url "#notify")}
            [:div.card-notify-me__title "Awaiting stock"]
            [:div.card-notify-me__link "Notify me"]])]]]

      [:div.product-features-card__text
       [:header
        [:h2.product-features-card__title
         [:span.product-features-card__brand brand
          [:span.u-hidden-from-view " "]]
         [:span.product-features-card__name name-ex-brand]]
        [:aside.product-features-card__meta
         (cond
           (> avg-rating 0)
           [:div
            {:class (u/bem :star-rating [(keyword (str avg-rating))]),
             :title (str rating " out of 5 stars from " num-reviews " reviews")}
            [:span.u-hidden-from-view
             (str rating " out of 5 stars from " num-reviews " reviews")]]

           :else
           [:div
            {:class (u/bem :star-rating [:00]),
             :title "This product has not been reviewed yet."}
            [:span.u-hidden-from-view "This product has not been reviewed yet."]])]]

       [:div.card__description
        [:ul.card-features-list
         (map
           (fn [feature]
             [:li {:key feature} feature])
           features)]]]]

     [:div.product-features-card__actions
      [:ul.card-price-list.group
       [:li {:class (u/bem :card-price-list__item [(when (> price-was price) :now)])}
        (when (and (> price 0) (> price-was price))
          [:span.u-hidden-from-view "Now "])

        (when (and (> price 0) (not (= price max-price)))
          "From ")

        (cond
          (and
            (= price 0)
            (or (= in-stock "Free") (= product-type "Online Cooking Course")))
          "Free"

          (= price 0)
          "Price TBA"

          (> price 0)
          (str "R" (u/currency-format price)))]

       (when (> price-was price)
         [:li
          {:class (u/bem :card-price-list__item [:was])}
          [:span
           {:class (u/bem :clip-text [:ml :t] :unclip-text [:l :s])}
           "Was "]
          (str "R" (u/currency-format price-was))])]

      (cond
        (u/presence special-short-desc)
        [:div.card__price-sticker-wrapper
         (cond
           (str/includes? (str/lower-case special-short-desc) (str/lower-case "worth"))
           [:div
            {:class (u/bem :card-sticker [:price])}
            (str/subs special-short-desc 0 (str/index-of (str/lower-case special-short-desc) (str/lower-case "worth")))
            [:span.clip-text--t.unclip-text--s
             (str/subs special-short-desc (str/index-of (str/lower-case special-short-desc) (str/lower-case "worth")))
             (when (> (or special-amount 0) 0)
               (str " R" (u/currency-format special-amount)))]]

           :else
           [:div
            {:class (u/bem :card-sticker [:price])}
            (str special-short-desc (when (> (or special-amount 0) 0) (str " R" (u/currency-format special-amount))))])]

        (and
          (> price-was price)
          (or
            (> (- price-was price) (/ price-was 10))
            (>= (- price-was price) 100)))
        [:div.card__price-sticker-wrapper
         [:div
          {:class (u/bem :card-sticker [:price])}
          "Save " (calculated-saving price price-was)]])

      (when (and (= in-stock "No") earliest-expected (dt/before? (dt/now) earliest-expected))
        [:p.card__stock-message
         {:class (u/bem :text-status [:important])}
         [:i
          {:class (u/bem :icon [:error-red :small :in-copy-left :inline])}]
         earliest-expected-message])

      [:ul.card-actions-list.group
       [:li.card-actions-list__item
        (cond
          (= in-stock "No")
          (buttons/button-web
            "Notify Me"
            {:href (str url "#notify")
             :style :primary
             :size :default
             :class :card-actions-list__button})

          (> (count variations) 1)
          (buttons/button-web
            (str "Choose "
              (cond
                (and (> (count variation-sizes) 0) (= (count variation-colours) 0))
                "Size"

                (and (> (count variation-colours) 0) (= (count variation-sizes) 0))
                "Colour"

                :else
                "Size/Colour"))
            (merge
              {:href url
               :style :primary
               :size :default
               :class :card-actions-list__button}
              (when stats
                {:on-click #(grid/dispatch-action app-atom :search/search-click-stats stats)})))

          :else
          (buttons/button-web "Add to Cart"
            {:style :primary
             :size :default
             :class :card-actions-list__button
             :on-click
             (fn [e]
               (.preventDefault e)
               (cond
                 new-cart-enabled
                 (do
                   (toaster/open-toast app-atom :processing "Adding item to cart" {})
                   (cart.model/add-to-cart app-atom
                     {:variation_uuid (str (:ent/uuid (first variations)))
                      :qty 1
                      :addsource "card-product-large"}
                     (fn [response]
                       (toaster/close-toast app-atom)
                       (cart.model/open-add-to-cart-modal app-atom response
                         :variation-uuid (str (:ent/uuid (first variations)))))))

                 :else
                 (web-common/add-to-cart
                   app-atom
                   {:url "/cart.htm?action=addtocart&addsource=card-product-large&carttype=mini&overrideincludes=ajax"
                    :params
                    {:contentid id
                     (keyword (str "qty" [(:variation/id (first variations))])) 1}})))}))]
       [:li.card-actions-list__item
        (buttons/button-web
          [:span.button__text
           "More"
           [:span
            {:class (u/bem :clip-text [:m] :unclip-text [:ml :t])}
            " Info"]]
          {:href url
           :style :secondary
           :size :default
           :class :card-actions-list__button})]]]]))

(rum/defc product-card-variation < rum/reactive
  ;; TODO: Need to decide on exactly what we do here...
  ;;  We have 2 options here:
  ;;    Either we add loads of configurable attributes on the default product card
  ;;    OR we create a standalone variation card (which I think is the simpler solution)
  ;; Currently, we use variation cards in 2 contexts:
  ;;     1. In the add to cart popup — views/templates/yuppiechef/desktop/order/cart/adddialog.tpl
  ;;     2. In registry starter collections — views/templates/yuppiechef/shared/registry/components/gift-registry-collection-card.tpl
  ;; And each one has different "keys", so I'm going to do my best below to pull out what I think are the important ones.
  ;; Ideally these would be standardised here in CLJ. There are a lot of descrepencies between TPL components.
  ;; It's always going to be best to compare our CLJC file to the TPLs by doing a printsafe on $item
  ;; I am, however, taking the opportunity here to extend this card with a "new" sticker, pack size, etc
  [app-atom {:keys [id variationid dateadded contentcollectionid position
                    showpreview variation contentid brand nameexbrand
                    price leadtime variationpicid img url avgrating numreviews
                    packsize all_packsizes packdescription new?]
             :as options}]
  ;; TODO: We need an option when calling product cards in CLJ to set them to "small",
  ;; like the default product card above.
  [:article.card.product-card.flex-grid-content
   [:div.card__hero
    [:a.u-block-link
     {:href url}
     (web-common/lazy-image app-atom
       img
       {:class ["card__image"]}
       {:w 233
        :h 233
        :c "lpad"
        :q "auto"
        :dpr 2
        :alt (str "Image of " (:name options))})
     ;; TODO: Need logic to check if this item is a new item:
     ;; `new` is something stored against the item in Solr,
     ;; but I'm unsure of how we check whether or not to show it.
     ;; In Smarty, we just use {? if $item.new ?}
     (when new?
       [:div.card__new-sticker-wrapper
        [:div {:class (u/bem :card-sticker [:new])} "New"]])
     ;; TODO: Need logic to check if we need to show a sticker.
     ;; This sticker could either be as a result of
     ;; — A time-based special, like Tick Tick Tuesday
     ;; — OR a sticker-name set on the categorry it's in, like 4-for-3
     ;; (`stickername` or `timebasedspecial` — both stored in Solr)
     ;; We also need to convert the stickers from Smarty to CLJ, just not sure how
     [:span.card__graphic-sticker-wrapper
      [:span {:class (u/bem :card__graphic-sticker [:time-based])}]]
     ;; TODO: Need logic to check if we must show a pack size
     ;; {? if $item.packsize>1 ?}
     [:div.card__pack-size-wrapper
      [:span.card__pack-size "Set of 16"]]]]
   [:div.card__content-wrapper
    [:a.u-block-link
     {:href url}
     [:div.card__content
      [:header.card__header
       ;; TODO: Need logic to check if we must show the the star rating.
       ;; The logic must sit inside the `product-card__meta` div, because
       ;; we show the div regardless for spacing / layout purposes
       ;; {? if $item.avgrating ?}
       [:div.product-card__meta
        ;; I know that my super basic logic below could be written much better. Soz
        (cond (> avgrating 0)
          [:div
           ;; TODO: Need to append `avgrating*10` to the star-rating CSS class, so that you end up with 4.5*10=45
           {:class (u/bem :star-rating [:45 :small]),
            :title (str avgrating "out of 5 stars from" numreviews "reviews")}
           [:span.u-hidden-from-view
            (str avgrating "out of 5 stars from" numreviews "reviews")]]
          :else
          [:div
           ;; TODO: Need to append `avgrating*10` to the star-rating CSS class, so that you end up with 4.5*10=45
           {:class (u/bem :star-rating [:00 :small]),
            :title "This product has not been reviewed yet."}
           [:span.u-hidden-from-view "This product has not been reviewed yet."]])]
       [:h1.product-card__title
        [:span.product-card__brand brand]
        [:span.product-card__name nameexbrand]]]
      [:div.card__description
       [:ul.card-price-list.group
        [:li.card-price-list__item price]]]]]
    ;; TODO: Need logic around this action button
    ;; If it's a registry collection item, show button and say "Add to Registry"
    ;; Else if it's in the Add to Cart popup, show button and say "Add to Cart"
    ;; Else if it's you can't do anything other than going to the variation page,
    ;; don't even show the button
    [:div.product-card__cta
     (buttons/button-web "Add to registry"
       {:href url
        :style :secondary
        :size :small
        :class :product-card__button})]]])

(rum/defc product-card-detail < rum/reactive
  ;; TODO: We store a lot of info against $item. Details below:
  ;; I'm specifying all the keys as they are stored in Solr against {? $item ?}
  ;; Same SOLR values as default product card above, but have also included product features in the last line :)
  ;; The product features are more complicated than I'm laying out below...
  ;; If you do a printsafe on {? $item.features|@printsafe ?} you'll get a better idea
  ;; The corresponding TPL is views/templates/shared/cards/card-product-large.tpl
  ;; A lot of the comments below are the same as the default product card above.
  [app-atom {:keys [id detailurl url img brand nameexbrand specialid
                    specialshortdesc specialbannertext specialdateto
                    stickername specialamount timebasedspecial
                    timebasedspecial_soldout earliestexpected
                    earliestexpectedmessage giftingperc dateadded
                    category producttype numwishlists numreviews itemsearchstats
                    price maxprice pricewas instock live score avgrating variations
                    card variations_all hassize hascolour packsize all_packsizes packdescription new?
                    colour numcolours colourBlock
                    fs_beantocupmilksystem fs_coffeetype fn_numberofcoffeepourers fn_pumppressure fn_watertankcapacity fn_beancapacity fs_warranty]
             :as options}]
  [:article.card.product-features-card.flex-grid-content
   [:div.product-features-card__content
    [:div.product-features-card__hero
     [:div.product-features-card__hero-outer
      [:div.product-features-card__hero-inner
       [:a.u-block-link
        ;; TODO: You'll need to check out the logic around URLs in the TPL.
        ;; In the TPL, there's actually some logic around URLs — need to check that out
        {:href url}
        (web-common/lazy-image app-atom
          img
          {:class ["card__image"]}
          {:w 233
           :h 233
           :q "auto"
           :c "lpad"
           :dpr 2
           :alt (str "Image of " (:name options))})
        ;; TODO: Need logic to check if this item is a new item.
        ;; `new` is something stored against the item in Solr,
        ;; but I'm unsure of how we check whether or not to show it.
        ;; In Smarty, we just use {? if $item.new ?}
        (when new?
          [:div.card__new-sticker-wrapper
           [:div {:class (u/bem :card-sticker [:new])} "New"]])
        ;; TODO: Need logic to check if we need to show a sticker.
        ;; This sticker could either be as a result of
        ;; — A time-based special, like Tick Tick Tuesday
        ;; — OR a sticker-name set on the categorry it's in, like 4-for-3
        ;; (`stickername` or `timebasedspecial` — both stored in Solr)
        ;; We also need to convert the stickers from Smarty to CLJ, just not sure how
        [:span.card__graphic-sticker-wrapper
         [:span {:class (u/bem :card__graphic-sticker [:time-based])}]]
        ;; TODO: Need logic to check if we must show a pack size
        ;; {? if $item.packsize>1 ?}
        [:div.card__pack-size-wrapper
         [:span.card__pack-size "Cases of 6 | 12 | 24"]]
        ;; TODO: Need logic to check if we must show colours
        ;; {? if $item.variations|@count>0 ?}
        ;; You can find exactly what we do here — views/templates/shared/blocks/colour-key.tpl
        ;; I've done some very basic logic here :)
        (cond (> numcolours 1)
          [:div.card__colour-key
           [:div.colour-key__description numcolours
            [:span.colour-key__qualifier
             {:data-abbr "clr"}
             [:span.colour-key__clip " colours"]]]
           [:div.colour-key__wrapper
            ;; TODO map over colours and show each one, showing up to 5
            [:div.colour-key__item {:style {:background-color "#ed1966"}}]
            [:div.colour-key__item {:style {:background-color "#00afd1"}}]
            [:div.colour-key__item {:style {:background-color "#37bc9b"}}]
            [:div.colour-key__item {:style {:background-color "#8cc152"}}]
            [:div.colour-key__item {:style {:background-color "#ffcb05"}}]]])]
       ;; TODO: Need logic to check if product is out of stock ($item.instock=="No")
       ;; This element needs to be outside the clickable <a> above, because it's clickable itself
       (when (= instock "No")
         [:a.card-notify-me
          ;; Not sure we need the mousedown remnant here
          {:href "#" :onmousedown ""}
          [:div.card-notify-me__title "Awaiting stock"]
          [:div.card-notify-me__link "Notify me"]])]]]
    [:div.product-features-card__text
     [:header
      ;; TODO: Need separate variables for brand and product name
      ;; I know that namexbrand is an issue on POS and has been for a long time.
      ;; We need to solve this :)
      [:h1.product-features-card__title
       [:span.product-features-card__brand brand
        [:span.u-hidden-from-view " "]]
       [:span.product-features-card__name nameexbrand]]
      ;; TODO: Need logic to check if we must show the the star rating.
      ;; The logic must sit inside the `product-card__meta` div, because
      ;; we show the div regardless for spacing / layout purposes
      ;; {? if $item.avgrating ?}
      ;; Please check the TPL to see what we do when there are no reviews — views/templates/shared/cards/card-product-standard.tpl
      [:aside.product-features-card__meta
       ;; I know that my super basic logic below could be written much better. Soz.
       (cond
         (and (> avgrating 0) (> numreviews 0))
         [:div
          {:class (u/bem :star-rating [:small] (str "star-rating--" (* avgrating 10)))
           :title (str avgrating " out of 5 stars from " numreviews " reviews")}
          [:span.u-hidden-from-view
           (str avgrating " out of 5 stars from " numreviews " reviews")]]
         :else
         [:div
          {:class (u/bem :star-rating [:small] (str "star-rating--" (* avgrating 10)))
           :title "This product has not been reviewed yet."}
          [:span.u-hidden-from-view "This product has not been reviewed yet."]])]]
     [:div.card__description
      [:ul.card-features-list
       [:li fs_beantocupmilksystem]
       [:li fs_coffeetype]
       [:li fn_numberofcoffeepourers]
       [:li fn_pumppressure]
       [:li fn_watertankcapacity]
       [:li fn_beancapacity]
       [:li fs_warranty]]]]]
   [:div.product-features-card__actions
    [:ul.card-price-list.group
     ;; TODO: Needs logic to check if there's a was price and add :now modifier accordingly
     [:li
      {:class (u/bem :card-price-list__item [:now])}
      [:span.u-hidden-from-view "Now "] price]
     [:li
      {:class (u/bem :card-price-list__item [:was])}
      [:span
       {:class (u/bem :clip-text [:ml :t] :unclip-text [:l :s])}
       "Was "]
      pricewas]]
    ;; TODO: Need logic to check if item has a special or was/now pricing
    ;; Look at TPL logic for more detail — quite a bit going on here
    [:div.card__price-sticker-wrapper
     [:div {:class (u/bem :card-sticker [:price])} "Save R1,500"]]
    ;; TODO: Need logic to check if out of stock and has an expected message
    [:p.card__stock-message
     {:class (u/bem :text-status [:important])}
     [:i {:class (u/bem :icon [:error-red :small :in-copy-left :inline])}]
     earliestexpectedmessage]
    [:ul.card-actions-list.group
     ;; TODO: Need logic to either show Add to Cart button, Notify Me, or Choose Colour button here
     [:li.card-actions-list__item
      (buttons/button-web "Add to Cart"
        {:href url
         :style :primary
         :size :default
         :class :card-actions-list__button})]
     [:li.card-actions-list__item
      (buttons/button-web
        [:span.button__text
         "More"
         [:span
          {:class (u/bem :clip-text [:m] :unclip-text [:ml :t])}
          " Info"]]
        {:href url
         :style :secondary
         :size :default
         :class :card-actions-list__button})]]]])

(rum/defc more-card < rum/reactive
  [{:keys [url text]
    :as options}]
  [:a.card.more-card.flex-grid-content
   {:href url}
   [:div.more-card__content
    [:div.more-card__text
     ;; TODO: Need to consider how best to pass text string to this component
     ;; Not sure this "View" is the best implementation, because we change this
     ;; completely in other contexts, e.g. /deals.htm, but first word as <b>
     ;; Other thing to note here is that this card will take on the height of its sibling cards
     ;; that are wrapped in grid wrappers.
     (cond
       (u/presence text)
       [:span
        {:dangerouslySetInnerHTML
         {:__html text}}]

       :else
       (list [:b "View"] "more"))
     [:div.more-card__arrow
      ;; TODO: This needs to use the icon component
      [:i
       {:class
        (u/bem :icon [:inline :medium-large :is-dark :arrow-right])}]]]]])

(defn guest-remove-from-cart [app-atom selected-item-atom]
  #?(:cljs
     (let [new-cart-enabled (cmn/curact app-atom [:features :new-cart])
           selected-item @selected-item-atom]
       (if new-cart-enabled
         ;; Use new cart model removal
         (let [registryitem-uuid (or (:item-line/uuid selected-item) (:uuid selected-item))
               cart-items (get-in @app-atom [:cart-summary :items])
               cartitems (filter #(when (= (str registryitem-uuid) (str (:forregistryitem_uuid %))) %) cart-items)
               cartitem-uuids
               (->>
                 cartitems
                 (take (or (:registry-item/purchase-qty selected-item) 1))
                 (map :cartitem_uuid))]
           (when cartitem-uuids
             (toaster/open-toast app-atom :processing "Removing item from cart" {})
             (ycweb.app.website.cart.model/remove-from-cart
               app-atom cartitem-uuids
               (fn [response]
                 (toaster/open-toast app-atom :success "Item removed" {})
                 (swap! selected-item-atom assoc :registry-item/in-cart? false)))))
         ;; Legacy PHP endpoint
         (do
           (toaster/open-toast app-atom :processing "Removing item from cart" {})
           (ajax/GET "/registry.htm"
             {:params
              {:action "removeFromGuestCart"
               :variationid (:item-line/variation-id selected-item)
               :overrideincludes "blank"}
              :handler
              (fn [response]
                (toaster/open-toast app-atom :success "Item removed" {})
                (swap! selected-item-atom assoc :registry-item/in-cart? false)
                (ycweb.components.grid/dispatch-action app-atom :web.common/cart-mini-qty {}))

              :error-handler
              (fn [response]
                (toaster/open-toast app-atom :error "Item could not be removed" {}))}))))))

(defn guest-add-to-cart [app-atom selected-item-atom]
  #?(:cljs
     (let [process-atom (cmn/process-cursor app-atom)
           {:registry/keys [can-edit? client-order]} (cmn/curact process-atom [:registry])
           new-cart-enabled (cmn/curact app-atom [:features :new-cart])]
       (when
         (or
           (not can-edit?)
           (js/confirm "This is your own registry. Are you sure you want to pay for something in your registry?"))
         (let [selected-item @selected-item-atom

               ;; Common data for both APIs
               variation-id (:item-line/variation-id selected-item)
               qty
               (* (:registry-item/purchase-qty selected-item)
                 (or (:variation/selling-pack-size (:item-line/variation selected-item)) 1))]

           (cond
             ;; Use new cart API via cart model abstraction
             new-cart-enabled
             (let [product-data
                   {:variation_uuid (str (get-in selected-item [:item-line/variation :ent/uuid]))
                    :qty qty
                    :addsource "registryordertable"
                    :forregistry_uuid (str (:client-order/uuid selected-item))
                    :forregistryitem_uuid (str (:item-line/uuid selected-item))}

                   complete-fn
                   (fn [response]
                     (toaster/close-toast app-atom)
                     (if (:success response)
                       (do
                         (grid/open-modal app-atom :web.registry/guest-add-item-modal
                           {:config
                            {:title "Item has been added"
                             :order-total
                             (str "R"
                               (u/currency-format
                                 (get-in @app-atom [:cart-summary :totals :total])))}})
                         (swap! selected-item-atom assoc :registry-item/in-cart? true))
                       (grid/open-modal app-atom :web.registry/guest-add-item-error-modal
                         {:config {:title "Item cannot be added"}})))]

               (toaster/open-toast app-atom :processing "Adding item to cart" {})
               (cart.model/add-to-cart app-atom product-data complete-fn))

             ;; Use legacy PHP endpoint
             :else
             (let [form-data
                   {:SPA true
                    :formid (str "form-" (:item-line/item-id selected-item))
                    :addsource "registryordertable"
                    :contentid (:item-line/product-id selected-item)
                    :registryorderid (:client-order/id client-order)
                    :forregistryitemid (:item-line/item-id selected-item)
                    :forregistryvariationid variation-id
                    (str "qty[" variation-id "]") (or (:variation/selling-pack-size (:item-line/variation selected-item)) 1)
                    :item_qty (:registry-item/purchase-qty selected-item)
                    :qty-available (:registry-item/available-qty selected-item)}
                   data (js/FormData.)]

               (doseq [[k v] form-data]
                 (.append data (name k) v))
               (toaster/open-toast app-atom :processing "Adding item to cart" {})

               (ajax/POST
                 "/registry.htm?action=addtoguestcart&overrideincludes=ajax"
                 {:body data
                  :response-format :json
                  :keywords? true
                  :handler
                  (fn [res]
                    (cond
                      (:success res)
                      (do
                        (toaster/close-toast app-atom)
                        (grid/dispatch-action app-atom :web.registry/guest-add-to-cart
                          {:res res
                           :title :item})
                        (swap! selected-item-atom assoc :registry-item/in-cart? true)
                        (grid/dispatch-action app-atom :web.common/cart-mini-qty {}))

                      :else
                      (do
                        (toaster/close-toast app-atom)
                        (grid/open-modal app-atom :web.registry/guest-add-item-error-modal
                          {:scan ""
                           :config
                           {:title "Item cannot be added"}})
                        (swap! selected-item-atom assoc :registry-item/in-cart? false))))
                  :error-handler
                  (fn [res]
                    (toaster/open-toast app-atom :error "Item not added to cart" {}))
                  :timeout 60000}))))))))

(rum/defc category-card < rum/reactive
  [app-atom
   {:keys [url-base sub-categories picture-public-id picture-url heading-type] :as options}]
  (let [sub-count (count sub-categories)
        display-name (u/presence (:ent/display-name options))]
    [:article.card.category-card.flex-grid-content
     {:class
      [(when (pos? sub-count) "category-list-card")
       (when-not display-name "category-card--no-title")]}
     (when (and picture-public-id picture-url)
       [:figure.card__hero
        [:a.block-link
         (urlstate/href-props app-atom url-base)
         (web-common/lazy-image app-atom
           picture-public-id
           {:class ["card__image"]}
           {:w 233
            :h 233
            :q "auto"
            :c "lpad"
            :dpr 2
            :alt (str "Image of " display-name)})]])
     (cond
       (pos? sub-count)
       [:div.card__content
        [:div.card__content-wrapper
         (when display-name
           [(or (#{:h2 :h3 :h4 :h5 :h6} (keyword (str "h" heading-type))) :h3) {:class "card__title"}
            [:a (urlstate/href-props app-atom url-base) display-name]])
         [:ul.card__index
          (map
            (fn [sub-cat]
              [:li.card-index__item
               [:a.card-index__link
                (urlstate/href-props app-atom (:url-base sub-cat))
                (:title sub-cat)]])
            (take 3 sub-categories))
          (when (> sub-count 3)
            [:li.card-index__item
             [:a
              (merge
                (urlstate/href-props app-atom url-base)
                {:class (u/bem :card-index__link [:more])})
              "More…"]])]]]

       :else
       [(or (#{:h2 :h3 :h4 :h5 :h6} (keyword (str "h" heading-type))) :h3) {:class "card__title"}
        [:a (urlstate/href-props app-atom url-base) display-name]])]))

(rum/defc registry-product-card < rum/reactive cmn/cursors {:key-fn (fn [_ _ registry-item] (:item-line/variation-id registry-item))}
  [app-atom edit-mode? registry-item]
  (let [process-atom (cmn/process-cursor app-atom)
        {:registry-item/keys [favourite? price paid-for-qty needed-qty available-qty]
         :item-line/keys [variation product qty variation-id]} registry-item

        selected-item-atom (rum/cursor-in process-atom [:registry :registry/client-order :client-order/items variation-id])

        ;; --- Begin new-cart aware in-cart? logic ---
        new-cart-enabled (cmn/curact app-atom [:features :new-cart])
        registryitem-uuid (or (:item-line/uuid registry-item) (:uuid registry-item))
        cart-items (cmn/curact app-atom [:cart-summary :items])

        in-cart-newcart?
        (when (and new-cart-enabled registryitem-uuid cart-items)
          (some #(= (str registryitem-uuid) (str (:forregistryitem_uuid %))) cart-items))
        ;; Use new-cart aware in-cart? if enabled, else fallback to local atom
        {:registry-item/keys [in-cart?]} (rum/react selected-item-atom)
        in-cart? (if new-cart-enabled in-cart-newcart? in-cart?)
        ;; --- End new-cart aware in-cart? logic ---

        {:product/keys [link name-ex-brand brand-name teaser reviews]} product
        {:variation/keys [features display-pack-size pack-description out-of-stock? discontinued?]} variation
        {:reviews/keys [stars-avg recommend-total reviews-total]} reviews]
    [:div
     {:class (u/bem :flex-grid-block [:ml-1-4 :t-1-2])}

     [:article.card.product-card.flex-grid-content
      [:div.card__hero
       [:a.u-block-link
        (if edit-mode?
          (urlstate/href-props app-atom link)
          (urlstate/href-on-click
            #(grid/dispatch-action app-atom :web.registry/product-preview-modal
               {:brand-name brand-name
                :name-ex-brand name-ex-brand
                :teaser teaser})))
        (when (u/presence (:doc/public-id (:ent/image variation)))
          [:div
           (web-common/lazy-image app-atom
             (:doc/public-id (:ent/image variation))
             {:class ["card__image"]}
             {:w 233
              :h 233
              :q "auto"
              :c "lpad"
              :dpr 2
              :alt (str "Image of " (:ent/display-name product))})])]
       (when favourite?
         [:div.product-card__favourite
          [:i
           {:class (u/bem :icon [:is-transparent :block :medium-large :is-dark :heart] :tooltip [:left]),
            :data-tooltip "Favourite"}]])]
      [:div.card__content-wrapper
       [:div.card__content
        [:a.u-block-link
         {:href link}
         [:div.js-card-match-content
          [:header.card__header
           (cond
             (and stars-avg (pos? stars-avg))
             [:div.product-card__meta
              [:div
               {:class (u/bem :star-rating [:small] (str "star-rating--" (u/number-format (* stars-avg 10) 0)))
                :title (str (int stars-avg) " out of 5 stars from " reviews-total " reviews")}
               [:span.u-hidden-from-view
                (str (int stars-avg) " out of 5 stars from " reviews-total " reviews")]]]

             :else
             [:div
              {:class (u/bem :star-rating [:small] "star-rating--0")
               :title "This product has not been reviewed yet."}
              [:span.u-hidden-from-view "This product has not been reviewed yet."]])

           [:h1.product-card__title
            [:span.product-card__brand brand-name]
            [:span.product-card__name
             name-ex-brand
             (when features (str ", " features))
             (when (and display-pack-size (> display-pack-size 1) pack-description)
               (str ", " pack-description " of " display-pack-size))]]]

          (when
            (or
              edit-mode?
              (not (and paid-for-qty needed-qty (>= paid-for-qty needed-qty))))
            [:div.card__description
             [:ul.card-price-list.group
              [:li.card-price-list__item
               (str "R" (u/currency-format (* price qty) 2))]]])]]

        [:div.product-card__registry-note
         (cond
           (and paid-for-qty (pos? paid-for-qty))
           (cond
             (and edit-mode? paid-for-qty needed-qty (>= paid-for-qty needed-qty))
             [:span
              {:class (u/bem :text-pill [:default :negative])}
              (str (when (> paid-for-qty 1) "All ") paid-for-qty " bought")]

             edit-mode?
             [:span
              {:class (u/bem :text-pill [:default :negative])}
              (str (when (and available-qty (pos? available-qty))
                     (str available-qty " still needed ")) paid-for-qty " bought")]

             (and paid-for-qty needed-qty (>= paid-for-qty needed-qty))
             [:span
              {:class (u/bem :text-pill [:default :negative])}
              "Sold"]

             :else
             (when (and available-qty (pos? available-qty))
               [:span {:class (u/bem :text-pill [:default :dark])}
                (str available-qty " needed")]))

           :else
           [:span
            {:class (u/bem :text-pill [:default :dark])}
            (when (and available-qty (pos? available-qty))
              (str available-qty " needed"))])]

        (when (and edit-mode? (or out-of-stock? discontinued?))
          [:div.product-card__registry-note
           [:span.u-text-12.u-text-underline
            {:class (u/bem :text-status [:important])}
            ;; Discontinued wins over out-of-stock
            (cond
              discontinued?
              [:a
               (urlstate/href-on-click #(grid/dispatch-action app-atom :web.cards/discontinued-popup {}))
               "Discontinued"]

              out-of-stock?
              [:a
               (urlstate/href-on-click #(grid/dispatch-action app-atom :web.cards/out-of-stock-popup {}))
               "Out Of Stock"])]])

        [:form
         [:div.product-card__form
          [:div
           {:class (u/bem :input-combo [:quantity :center])}
           (when (or edit-mode? (and available-qty (pos? available-qty)))
             (buttons/button-web ""
               {:type :button
                :style :secondary
                :size :small
                :on-click
                (fn []
                  (cond
                    edit-mode?
                    (grid/dispatch-action app-atom :web.registry/edit.remove-item
                      {:registry-item/variation-id (:item-line/variation-id @selected-item-atom)
                       :registry/uuid (:registry/uuid @selected-item-atom)})
                    :else
                    (swap! selected-item-atom update-in [:registry-item/purchase-qty] #(max 1 (dec %)))))
                :combo true
                :icon-only true
                :icon :minus
                :hidden-text "Remove 1"}))
           (forms/input-raw ""
             (rum/cursor selected-item-atom (if edit-mode? :registry-item/needed-qty :registry-item/purchase-qty))
             {:type :text
              :class "text-input--small"
              :size 3
              :default qty
              :read-only true})
           (when (or edit-mode? (and available-qty (pos? available-qty)))
             (buttons/button-web ""
               {:type :button
                :style :secondary
                :size :small
                :on-click
                (fn []
                  (cond
                    edit-mode?
                    (grid/dispatch-action app-atom :web.registry/edit.add-item
                      {:registry-item/variation-id (:item-line/variation-id @selected-item-atom)
                       :registry/uuid (:registry/uuid @selected-item-atom)})
                    :else
                    (swap! selected-item-atom update-in [:registry-item/purchase-qty] #(min available-qty (inc %)))))
                :combo true
                :icon-only true
                :icon :plus
                :hidden-text "Add 1"}))]]

         (cond
           edit-mode?
           [:div.product-card__cta
            (buttons/button-web "Favourite"
              {:type :button
               :style :secondary
               :size :small
               :icon :heart
               :class :product-card__button
               :on-click
               (fn []
                 (grid/dispatch-action app-atom :web.registry/edit.update-favourite
                   #:registry
                    {:id (:registry/id @selected-item-atom)
                     :registry-item
                     #:registry-item
                      {:variation-id (:item-line/variation-id @selected-item-atom)
                       :favourite? (not (:registry-item/favourite? @selected-item-atom))}}))})]
           :else
           [:div.product-card__cta
            (cond
              in-cart?
              (buttons/button-web "Remove from Cart"
                {:type :button
                 :style :secondary
                 :size :small
                 :icon :minus
                 :class :product-card__button
                 :on-click
                 (fn [e]
                   (.preventDefault e)
                   (guest-remove-from-cart app-atom selected-item-atom))})
              (and available-qty (pos? available-qty))
              (buttons/button-web "Add to Cart"
                {:type :button
                 :style :secondary
                 :size :small
                 :icon :plus
                 :class :product-card__button
                 :on-click
                 (fn [e]
                   (.preventDefault e)
                   (guest-add-to-cart app-atom selected-item-atom))})
              :else
              (buttons/button-web "Sold"
                {:type :button
                 :style :secondary
                 :size :small
                 :disabled true
                 :class :product-card__button}))])]]]]]))

;; REGISTRY CARD: Out of Stock Modal
(rum/defc out-of-stock-body < rum/reactive [app-atom config-atom]
  (let [config (cmn/curact config-atom :config)]
    (list
      [:div.yc-popup
       (headings/heading "Item Out Of Stock"
         {:type :h2
          :size :small})
       [:p.yc-paragraph
        [:b
         {:class (u/bem :text-status [:important])}
         "This item is currently out of stock with us and our supplier."]
        " We hope it will come back into stock by the time you close your Registry. However, if we are concerned that it may not, it will be hidden from your Registry's \"Guest View\" temporarily so that your guests won't be able to purchase it."]
       [:p.yc-paragraph
        "Learn more about this in our "
        [:a
         {:href
          "/help.htm?action=article&id=37&name=Managing-Your-Registry#heading5",
          :class (u/bem :text-link [:muted])}
         "Help Centre."]]])))

(defmethod grid/modal-config :web.cards/out-of-stock-popup [_ _ _]
  {:body-raw out-of-stock-body
   :modal-type :variable})

(defmethod grid/action :web.cards/out-of-stock-popup [app-atom config _]
  (grid/open-modal app-atom :web.cards/out-of-stock-popup
    {:scan ""
     :config
     {:title "Out of Stock"}}))

;; REGISTRY CARD: Discontinued Modal
(rum/defc discontinued-body < rum/reactive [app-atom config-atom]
  (let [config (cmn/curact config-atom :config)]
    (list
      [:div.yc-popup
       (headings/heading "Item Discontinued" {:type :h2 :size :small})
       [:p.yc-paragraph
        "This item has, unfortunately, been discontinued since you added it to your Registry and has been removed from your Registry's \"Guest View\" so that your guests won't be able to purchase it."]
       [:p.yc-paragraph
        "If it has already been purchased by a guest, you will be able to swap it for something else of the same value when you close your Registry, or take a Gift Voucher instead."]
       [:p.yc-paragraph
        "Learn more about this in our "
        [:a
         {:href
          "/help.htm?action=article&id=37&name=Managing-Your-Registry#heading5",
          :class (u/bem :text-link [:muted])}
         "Help Centre."]]])))

(defmethod grid/modal-config :web.cards/discontinued-popup [_ _ _]
  {:body-raw discontinued-body
   :modal-type :variable})

(defmethod grid/action :web.cards/discontinued-popup [app-atom config _]
  (grid/open-modal app-atom :web.cards/discontinued-popup
    {:scan ""
     :config
     {:title "Out of Stock"}}))

(rum/defc trend-pill [title colour & [text-colour]]
  [:li.trend-card__attrs-item
   [:span
    {:class [(when text-colour (str "u-text-" (name text-colour))) (str "u-bg-" (name colour)) (u/bem :text-pill [:tiny])]}
    title]])

(rum/defc trend-card < rum/reactive [app-atom item card-details? large-text?]
  (let
    [{:item-line/keys [product variation]} item
     {:product/keys [name-ex-brand brand-name status product-type primary-category edison-stone? exclusive?]} product
     {:variation/keys
      [features code price cost-price margin store-sales-for-period store-income-for-period store-sellability
       total-sales-for-period total-income-for-period online-sellability core? seasonal? suggested? store-remove? delist?
       time-live stores-ranged]} variation
     {:keys [product-rating product-details print?]} (cmn/curact (cmn/process-cursor app-atom) [:settings])
     selected-items-atom (rum/cursor-in (cmn/process-cursor app-atom) [:selected])
     selected? (cmn/curact selected-items-atom [(:variation/id variation)])
     product-details true]                                       ;;TODO: Get is selected working
    [:div
     {:class
      (u/bem :trend-card [(when (and selected? (not print?)) :is-selected) (when (or store-remove? delist?) :is-deranged) (when large-text? :big-text-mode)])}
     [:div.trend-card__hero
      ;; This whole section is clickable
      [:a.u-block-link
       {:href (str "/admin/products_edit.htm?overrideincludes=popup&sm[e1][action]=contentedit&sm[e1][cntid]=" (:product/id product))
        :target "_blank"}
       ;; TODO: Lazy loading is not a great option for print, fix this
       #_[:img
          {:style
           {:width "556"
            :height "556"}
           :class (u/bem :image ["trend-card__image"])
           :src (u/cloudinary (:doc/public-id (:ent/image variation)) {}) :alt ""}]
       (web-common/lazy-image app-atom
         (if (:doc/public-id (:ent/image variation))
           (:doc/public-id (:ent/image variation))
           "ui-resources/admin-dashboard/no-image")
         {:class ["trend-card__image"]}
         {:w 556
          :h 556
          :c "lpad"
          :f "auto"})]
      ;; TODO: logic needs to surround these pills
      (when card-details?
        [:ul.trend-card__attrs
         (when false
           (trend-pill "Newly listed" :peacock))
         (when edison-stone?
           (trend-pill "Edison Stone" :oil))
         (when exclusive?
           (trend-pill "Exclusive" :greenery))
         (when core?
           (trend-pill "Core" :casablanca :oil))
         (when seasonal?
           (trend-pill "Seasonal" :terracotta))
         (when (and (= (or stores-ranged 0) 0) (not delist?) (not store-remove?))
           (trend-pill "Proposed" :iris))
         (when suggested?
           (trend-pill "Suggested" :pink))
         (when delist?
           (trend-pill "Delist" :red))
         (when (and store-remove? (not delist?))
           (trend-pill "Derange Store" :red))])
      (when print?
        [:a.trend-card__options-button.u-do-not-print
         {:on-click
          #(grid/open-modal app-atom :admin.merchandising/remove-item
             {:config
              {:title "Remove"
               :variation-id (:variation/id variation)}})}
         [:i
          {:class
           (u/bem :icon [:delete :is-dark :default :block])}
          [:span.u-hidden-from-view "Open opens menu for this product"]]])]
     [:div.trend-card__content
      [:h2.trend-card__title
       [:span.trend-card__brand brand-name]
       [:span.trend-card__name name-ex-brand]
       [:span.trend-card__variant (str code (when (u/presence features) " - ") features)]]
      ;; TODO: we may need a map and logic here to catch and list every category/collection this item is in.
      (when product-details
        [:div.trend-card__details
         (into
           [:ul.trend-card-stats
            (when card-details?
              [:li.trend-card-stats__item
               [:span.trend-card-stats__key]
               [:span.trend-card-stats__value "Online | Store"]])
            [:li.trend-card-stats__item
             [:span.trend-card-stats__key [:b "Retail:"]]
             [:span.trend-card-stats__value [:b (str "R" (u/currency-format price))]]]
            [:li.trend-card-stats__item
             [:span.trend-card-stats__key [:b "Margin:"]]
             [:span.trend-card-stats__value [:b (str (u/number-format margin 2) "%")]]]
            (when card-details?
              (list
                [:li.trend-card-stats__item
                 [:span.trend-card-stats__key "Cost:"]
                 [:span.trend-card-stats__value (str "R" (u/currency-format cost-price 2))]]
                (when-not suggested?
                  [:li.trend-card-stats__item
                   [:span.trend-card-stats__key "Total Income:"]
                   [:span.trend-card-stats__value (str (str "R" (u/human-readable-currency total-income-for-period)) " | " (str "R" (u/human-readable-currency store-income-for-period)))]])
                (when-not suggested?
                  [:li.trend-card-stats__item
                   [:span.trend-card-stats__key "Total Units Sold:"]
                   [:span.trend-card-stats__value (str (u/number-format total-sales-for-period) " | " (u/number-format store-sales-for-period))]])
                (when-not suggested?
                  [:li.trend-card-stats__item
                   [:span.trend-card-stats__key "Stocked:"]
                   [:span.trend-card-stats__value (str (str (u/number-format online-sellability) "%") " | " (u/number-format store-sellability))]])
                [:li.trend-card-stats__item
                 [:span.trend-card-stats__key "Status:"]
                 [:span.trend-card-stats__value (if suggested? "Suggested" status)]]
                (when-not suggested?
                  [:li.trend-card-stats__item
                   [:span.trend-card-stats__key "Time live:"]
                   [:span.trend-card-stats__value time-live]])
                (when-not suggested?
                  [:li.trend-card-stats__item
                   [:span.trend-card-stats__key "Grade:"]
                   [:span.trend-card-stats__value (:type/price product-type)]])
                (when (and (not suggested?) (:ent/display-name primary-category))
                  [:li.trend-card-stats__item
                   [:span.trend-card-stats__description (:ent/display-name primary-category)]])
                (when (when (not suggested?) (:ent/display-name product-type))
                  [:li.trend-card-stats__item
                   [:span.trend-card-stats__description
                    (:ent/display-name product-type)]])))])])]]))

(rum/defc cards [app-atom]
  [:div
   {:class (u/bem :yc-page-content [:standard])}
   [:div
    {:class (u/bem :yc-section [:medium-underline])}
    (headings/heading "Default product card" {:type :h1 :size :default :center true})
    [:div.flex-grid-group
     [:div
      ;; The key thing to note here is that cards don't have a predefined or max size of their own —
      ;; i.e. cards will always take on the width of the parent, which is why wrapping grid divs are important.
      ;; This needs to be separate from the component itself, but important to understand this.
      {:class (u/bem :flex-grid-block [:ml-1-4 :t-1-2])}
      (product-card-default app-atom
        {:url "/le-creuset.htm"
         :img "/contentdocs/52969/otherpicture320210329222614"
         :brand "Royal Comfort"
         :name-ex-brand "Premium Hungarian Goose Down Winter Duvet Inner, 90% Down"
         :earliestexpectedmessage "Expected early February"
         :numreviews 112
         :price "R88,888"
         :pricewas "R99,999"
         :avgrating 45
         :numcolours 14
         :new? true
         :instock "Yes"}
        {})]]]
   [:div
    {:class (u/bem :yc-section [:medium-underline])}
    (headings/heading "Variation product card" {:type :h1 :size :default :center true})
    [:div.flex-grid-group
     [:div
      ;; The key thing to note here is that cards don't have a predefined or max size of their own —
      ;; i.e. cards will always take on the width of the parent, which is why wrapping grid divs are important.
      ;; This needs to be separate from the component itself, but important to understand this.
      {:class (u/bem :flex-grid-block [:ml-1-4 :t-1-2])}
      (product-card-variation app-atom
        {:url "/le-creuset.htm"
         :img "contentdocs/35439/otherpicture320200804093304"
         :brand "Maxwell & Williams"
         :nameexbrand "White Basics Diamonds Round 16 Piece Dinner Set"
         :numreviews 112
         :avgrating 35
         :price "R1,699"
         :new? true})]]]
   [:div
    {:class (u/bem :yc-section [:medium-underline])}
    (headings/heading "Details / Features product card" {:type :h1 :size :default :center true})
    [:div.flex-grid-group
     [:div
      ;; The key thing to note here is that cards don't have a predefined or max size of their own —
      ;; i.e. cards will always take on the width of the parent, which is why wrapping grid divs are important.
      ;; This needs to be separate from the component itself, but important to understand this.
      {:class (u/bem :flex-grid-block [:t-full])}
      (product-card-large app-atom
        {:url "/le-creuset.htm"
         :img "contentdocs/52969/otherpicture320210329222614"
         :brand "Royal Comfort"
         :name-ex-brand "Premium Hungarian Goose Down Winter Duvet Inner, 90% Down"
         :earliestexpectedmessage "Expected early February"
         :numreviews 112
         :price "R88,888"
         :pricewas "R99,999"
         :avgrating 45
         :numcolours 14
         :fs_beantocupmilksystem "Milk System: Milk Pipe"
         :fs_coffeetype "Coffee Type: Beans"
         :fn_numberofcoffeepourers "Number of Coffee Pourers: 2 Cups"
         :fn_pumppressure "Pump Pressure: 15 bar"
         :fn_watertankcapacity "Water Capacity: 1.90 Litres"
         :fn_beancapacity "Bean Capacity: 280 grams"
         :fs_warranty "Warranty: 2 Year"
         :new? true
         :instock "Yes"})]]]
   [:div
    {:class (u/bem :yc-section [:medium-underline])}
    (headings/heading "More card" {:type :h1 :size :default :center true})
    [:div.flex-grid-group
     [:div
      ;; The key thing to note here is that cards don't have a predefined or max size of their own —
      ;; i.e. cards will always take on the width of the parent, which is why wrapping grid divs are important.
      ;; This needs to be separate from the component itself, but important to understand this.
      {:class (u/bem :flex-grid-block [:ml-1-4 :t-1-2])}
      (more-card
        {:url "/index.htm"
         :text "Le Creuset"})]]]
   [:div
    {:class (u/bem :yc-section [:medium-underline])}
    (headings/heading "Category card" {:type :h1 :size :default :center true})
    [:div.flex-grid-group
     [:div
      ;; The key thing to note here is that cards don't have a predefined or max size of their own —
      ;; i.e. cards will always take on the width of the parent, which is why wrapping grid divs are important.
      ;; This needs to be separate from the component itself, but important to understand this.
      {:class (u/bem :flex-grid-block [:ml-1-4 :t-1-2])}
      (category-card app-atom
        {:url "/index.htm"
         :title "Knives"
         :picture_public_id "category/241/matrix34colPicture1611763507"
         :subcategories 0})]]]
   [:div
    {:class (u/bem :yc-section [:large])}
    (headings/heading "Registry product card" {:type :h1 :size :default :center true})
    [:div.flex-grid-group
     [:div
      {:class (u/bem :flex-grid-block [:ml-1-4 :t-1-2])}
      (registry-product-card app-atom false
        {:link "/index.htm"
         :public_id "contentdocs/52589/picture20210413141758"
         :name "Royal Comfort Premium Hungarian Goose Down Winter Duvet Inner, 90% Down"
         :nameexbrand "Premium Hungarian Goose Down Winter Duvet Inner, 90% Down"
         :brandname "Royal Comfort"
         :avgstars 35
         :totalreviews 87
         :qty_needed 3
         :qty_sold 3
         :favourite true})]]]])

(defmethod flow/render-screen :web.cards [app-atom _]
  (cards app-atom))